import { forwardRef, type Ref, type SVGProps } from "react";
const IconMultiFamilyOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M14.817 2.48a2.5 2.5 0 0 1 2.366 0L27.3 8.012c.662.362 1.065 1.001 1.065 1.69v18.129c0 1.097-1.007 1.986-2.248 1.986H5.884c-1.241 0-2.248-.89-2.248-1.986V9.702c0-.688.403-1.327 1.065-1.689zm.96 1.754a.5.5 0 0 1 .446 0L26.34 9.768l.025.015V27.75a.43.43 0 0 1-.248.067h-3.57v-7.09c0-.603-.48-1.092-1.072-1.092h-3.312c-.591 0-1.071.489-1.071 1.091v7.091H14.91v-7.09c0-.603-.48-1.092-1.071-1.092h-3.312c-.592 0-1.071.489-1.071 1.091v7.091h-3.57a.43.43 0 0 1-.249-.067V9.783l.025-.015z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMultiFamilyOutlineSVG);
ForwardRef.displayName = "IconMultiFamilyOutline";
export { ForwardRef as IconMultiFamilyOutline };
